module.exports = "<p>\n  maintenance-board works!\n</p>\n"